import { VisuallyHidden, Badge } from '@buffer-mono/popcorn'

export const CommentsCount = ({
  count,
  className,
  variant = 'brand',
  size = 'xsmall',
}: {
  count: number
  className?: string
  variant?: 'brand' | 'brand-subtle'
  size?: 'xsmall' | 'small'
}): JSX.Element => {
  return (
    <span>
      <Badge variant={variant} size={size} className={className}>
        {count > 99 ? '99+' : count}
      </Badge>
      <VisuallyHidden> new comments</VisuallyHidden>
    </span>
  )
}
